exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".info-field-value[data-v-460c2bef]{width:100%}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Software/AddVersion.vue"],"names":[],"mappings":"AACA,mCACI,UAAY,CACf","file":"AddVersion.vue","sourcesContent":["\n.info-field-value[data-v-460c2bef] {\n    width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-460c2bef","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Software/AddVersion.vue
// module id = 2354
// module chunks = 11